<template>
    <div>
         <el-tabs v-model="activeNames" @tab-click="handleClick">
            <el-tab-pane label="价格信息" name="first" id="downPdf">
                <el-row>
                    <el-col :span="10">
                        <el-form
                            style="width:400px"
                            :model="timePriceForm"
                            ref="timePriceForm"
                            :rules="timePriceRules"
                            label-width="120px"
                            inline
                            >
                                <el-form-item 
                                    label="产品" 
                                    prop="product"  
                                    style="width: 100%">
                                    <el-input v-model="timePriceForm.product" :disabled="true" style="width: 200px" maxlength="10" show-word-limit></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="调价(元/吨)"
                                    prop="realPrice"
                                    style="width: 100%"
                                >
                                    <el-input
                                    v-model="timePriceForm.realPrice"
                                    style="width: 116%"
                                    placeholder="请输入调价价格"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="执行时间"
                                    prop="time"
                                    style="width: 100%"
                                >
                                <el-date-picker
                                    v-model="timePriceForm.time"
                                    type="datetime"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd HH:mm"
                                    format="yyyy-MM-dd HH:mm"
                                    placeholder="请选择执行时间">
                                    </el-date-picker>
                                </el-form-item>
                                
                                <el-form-item label="例外企业">
                                    <el-select v-model="selectInput" filterable placeholder="请选择例外企业" @change="selectCompany">
                                        <el-option
                                        v-for="item in companys"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                
                                <div class="select-company" v-for="(item,index) in select_company_arr" :key="index">
                                    <p class="select-company-title">{{ item.name }}</p>
                                    <svg-icon icon-class="del" style="padding-right: 5px;margin-right: 10px;color: red;" @click="deleteCompany(item)"/>
                                </div>
                                
                                <el-form-item style="width: 100%; text-align: center">
                                    <el-button
                                    plain
                                    v-can="['btn:price_adjustment']"
                                    type="primary"
                                    :loading="is_post"
                                    @click="submitTimePriceChange"
                                    >确认调价</el-button
                                    >
                                    <el-button v-if="timePriceForm.product=='LNG'"
                                    plain
                                    type="primary"
                                    v-can="['btn:letter_price']"
                                    :loading="is_post"
                                    @click="submitPriceChange"
                                    >生成价格确认函</el-button
                                    >
                                </el-form-item>

                                <el-form-item v-if="price_history_list.length>0">
                                    <el-table
                                    :data="price_history_list"
                                    style="width: 100%;margin-left: 10%;">
                                    <el-table-column label="调价" width="80px" align="right">
                                        <template slot-scope="scope">
                                           <span>{{ parseFloat(scope.row.newPrice).toFixed(2) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="exeTime" label="执行时间" width="170px" align="center"></el-table-column>
                                    <el-table-column label="是否执行" align="center">
                                        <template slot-scope="scope">
                                            <span v-show="scope.row.used" style="color: #1890ff;">已执行</span>
                                            <span v-show="!scope.row.used" style="color: red;">未执行</span>
                                        </template>
                                    </el-table-column>
                                    </el-table>
                                </el-form-item>
                            </el-form>
                    </el-col>

                    <el-col :span="9" v-if="isPriceChange==true">
                        <div style="text-align: left;width: 100%">
                            <div>
                                <img
                                    style="width: 150px; height: 118px;border-radius:10px;margin-bottom:12px;"
                                :src="require('../../../assets/img/lng.png')"
                                />
                            </div>
                           
                            <div class="boxLine"></div>
                            <div class="priceHeight boxFlexCenter boxTitle">陕西靖边星源实业有限公司</div>
                            <div class="priceMargin priceHeight boxFlexCenter boxTitleS">LNG价格确认函</div>
                            <div class="priceMargin priceHeight boxBold">致：贵公司</div>
                            <div class="textIndent priceHeight">根据当前LNG市场行情，我公司定于<span class="fontColor" v-if="timePriceForm.time!=''" v-html="formateTimeStamp(timePriceForm.time)"></span>起，价格调整为<span class="fontColor">{{timePriceForm.realPrice}}</span>元/吨（<span class="fontColor">自提</span>、含税）。</div>
                            <div class="textIndent priceHeight">结算价格以车辆进厂过磅时间为准。之后根据市场情况变化可能随时进行浮动调整，如遇价格调整我公司会提前做出通知。</div>
                            <div class="textIndent priceMargin priceHeight">烦请贵司收到此函后及时盖章确认并回传，在此价格执行期间未回复确认，但派车到我公司装车的视为认同此价格。</div>
                            <div class="textIndent priceHeight">如有其他事项由双方具体协商确定。</div>
                            <div class="textIndent priceHeight">以上内容如无疑议，请贵司予以盖章确认回复。</div>
                            <div class="textIndent priceHeight">顺颂商祺！</div>
                            <div  class="textIndent priceHeight boxFlexBetween">
                                <div class="boxPlace">（客户签章处）</div>
                                <div style="position:relative;width:60%;text-align: center;">
                                    <img class="box-img" :src="require('../../../assets/img/specialSeal.jpg')"/>
                                    <div style="position:absolute;top:25%;">
                                        <div class="priceHeight boxFlexEnd">陕西靖边星源实业有限公司销售部</div>
                                        <div class="priceHeight boxFlexEnd"><span v-if="timePriceForm.time!=''" v-html="formateTimeStamp1(timePriceForm.time)"></span></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </el-col>
                </el-row>
                
            </el-tab-pane>
            <el-tab-pane label="长期优惠" name="second">
                 <el-form :model="temForm" ref="temForm" label-width="150px">
                            <el-alert
                                title="每个计划单固定的优惠金额"
                                style="margin-bottom: 20px"
                                type="warning">
                            </el-alert>
                            <el-form-item label="长期优惠金额(元/吨)" prop="temCutPrice" :rules="[
                                { required: true, message: '请填写长期优惠金额', trigger: 'blur' },
                                { pattern: /^[0-9]\d*$/, message: '请填写一个正整数', trigger: 'blur' }
                            ]">
                                <el-input v-model="temForm.temCutPrice" placeholder="长期优惠金额(元/吨)" style="width: 200px"></el-input>
                            </el-form-item>
                            <el-form-item label="是否启用">
                                <el-switch
                                    v-model="temForm.isTemCut"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-text="是"
                                    inactive-text="否">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="" v-can="['btn:long_discounts_add']">
                                <el-button type="primary" plain :loading="is_post" @click="saveTemForm">保 存</el-button>
                            </el-form-item>
                        </el-form>
            </el-tab-pane>
            <el-tab-pane label="销售员优惠" name="third">
                <el-alert
                            title="销售员可以自己决定的最大优惠金额(超过该额度则需要审批)"
                            style="margin-bottom: 20px"
                            type="warning">
                        </el-alert>
                        <el-form :model="allowForm" ref="allowForm" label-width="150px">
                            <el-form-item label="销售员优惠额度" prop="allowQuota" :rules="[
                                { required: true, message: '请填写销售员优惠额度', trigger: 'blur' },
                                { pattern: /^[0-9]\d*$/, message: '请填写一个正整数', trigger: 'blur' }
                            ]">
                                <el-input v-model="allowForm.allowQuota" placeholder="销售员优惠额度(元)" style="width: 200px"></el-input>
                            </el-form-item>
                            <el-form-item label="" v-can="['btn:sales_discounts_add']">
                                <el-button type="primary" plain :loading="is_post" @click="saveAllowForm">保 存</el-button>
                            </el-form-item>
                        </el-form>
            </el-tab-pane>
            <el-tab-pane label="车辆优惠" name="fourth" v-if="checkPermission(['btn:vehicle_discount_viewing'])" >
                <el-card class="page_card_tab" ref="card">
                    <div class="search-box">
                        <el-form :inline="true" ref="selectVehicleForm" :model="selectVehicleForm" class="demo-form-inline">
                            <el-form-item label="主车号">
                                <el-input placeholder="请输入主车号" v-model="selectVehicleForm.plateNumber"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button plain type="primary"  @click="selectSubmit()">查询</el-button>
                                <el-button plain  @click="resetSelect()">重置</el-button>
                                <el-button plain type="success" v-can="['btn:car_discounts_add']" @click="goToAdd()">+ 新增车辆优惠</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="font-style"><span>共 {{discountNum}} 车</span></div>
                    </div>

                    <!-- 列表 -->
                    <el-table :data="vehicle_list" :max-height="tableMaxHeight" style="width:96%;margin-left:2%;">
                        <el-table-column label="主车号">
                            <template slot-scope="scope">
                                <span class="primary_text">{{ scope.row.plateNumber }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="优惠金额">
                            <template slot-scope="scope">
                                <span class="primary_text">{{parseNums(scope.row.price )}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="开始时间">
                            <template slot-scope="scope">
                                <span class="primary_text">{{ scope.row.beginDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="结束时间">
                            <template slot-scope="scope">
                                <span class="primary_text">{{ scope.row.endDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <a style="color:#1890ff;" v-can="['btn:car_discounts_editor']" @click="handleEdit(scope.$index, scope.row)">编辑</a>
                                <a style="color:red;margin-left:12px;" v-can="['btn:car_discounts_delete']" @click="handleDel(scope.$index, scope.row)">删除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                    <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
                        <el-pagination
                            style="float: left;position: relative;top: 10px;"
                            @current-change="pageChange"
                            :current-page.sync="selectVehicleForm.pageNum"
                            :page-size="selectVehicleForm.pageSize"
                            :hide-on-single-page="false"
                            layout="prev, pager, next, jumper"
                            :total="total">
                        </el-pagination>
                    </footer>
                </el-card>
            </el-tab-pane>
            <el-tab-pane label="修改产品" name="five">
                  <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item label="产品名称" prop="name">
                        <el-input v-model="form.name" :disabled="!has_permission('btn:edit_product')" style="width: 200px" placeholder="请输入产品名称" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="产品图片" prop="imgUrl">
                        <div>
                            <el-image
                                style="width: 180px; height: 160px;border-radius:10px;"
                                :src="form.imgUrl"
                                fit="contain">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="has_permission('btn:edit_product')">
                        <div>
                            <input type="file" name="file" style="display:none;" ref="upload_file" @change="file_change($event)">
                            <el-button type="primary" plain :loading="is_upload" @click="choseImg()">{{is_upload?'正在上传...':'选择图片'}}</el-button>
                        </div>
                        <div style="font-size: 12px;color: #aaa">
                            只能上传jpg,jpeg,png,gif格式的图片,且大小不能大于500KB
                        </div>
                    </el-form-item>

                    <el-form-item label="是否主产品" v-if="mode != 'add'" v-can="['btn:edit_product']">
                        <el-switch
                            v-model="form.isMain"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否">
                        </el-switch>
                    </el-form-item>
                    <!-- <el-form-item label="是否启用" v-if="mode != 'add'" v-can="['btn:edit_product']">
                        <el-switch
                            v-model="form.isShow"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否">
                        </el-switch>
                    </el-form-item> -->
                    <el-form-item label="当前执行价" v-if="mode != 'add'">
                        <span class="primary_text">{{data.price}} 元/吨</span>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain :loading="is_post" type="warning" @click="editSubmit" v-can="['btn:modify_product']">保存修改</el-button>
                        <el-button plain :loading="is_post" type="danger" v-can="['btn:product_delete']" @click="deleteSubmit()" >删 除</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>

        </el-tabs>
        <!-- 车辆优惠 -->
        <el-dialog :title="add_prcie ? '添加车辆优惠' : '修改车辆优惠'" :visible.sync="add_discounts_dialog" width="23%" @close="closeing">
              <el-form  label-position="center" label-width="100px" ref="addPerf" :model="addPerf"  :rules="pref">
                <el-form-item label="主车号" prop="plateNumber" v-if='add_prcie'>
                        <el-input v-model="addPerf.plateNumber" @input="plateNumberInput" placeholder="请输入主车号: 宁A12L45" maxlength="7" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="主车号" prop="plateNumber" v-else>
                        <el-input v-model="addPerf.plateNumber" @input="plateNumberInput" :disabled="true" placeholder="请输入主车号: 宁A12L45" maxlength="7" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="优惠价格" prop="price">
                    <el-input placeholder="请输入优惠价格" v-model="addPerf.price"></el-input>
                </el-form-item>
                <el-form-item label="开始日期" prop="beginDate">
                    <el-date-picker v-model="addPerf.beginDate" style="width:100%" value-format="yyyy-MM-dd" type="date" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                 <el-form-item label="结束日期" prop="endDate">
                    <el-date-picker v-model="addPerf.endDate" style="width:100%" value-format="yyyy-MM-dd" type="date" placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item class="btn-save">
                    <el-button v-if='add_prcie' plain type="primary" @click="addPrefSubmit()">确认</el-button>
                    <el-button v-else plain type="primary" @click="editPrefSubmit()">修改保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="(allFormType == 'add'?'添加':'修改')+'全局优惠规则'" :visible.sync="add_dialog" width="30%">
            <el-form ref="allForm" :model="allForm" label-width="140px" :rules="allFormRules">
                <el-form-item label="满足采购量(吨)" prop="conditionNum">
                    <el-input v-model="allForm.conditionNum" placeholder="满足采购量(吨)"></el-input>
                </el-form-item>
                <el-form-item label="每吨优惠额(元/吨)" prop="cutPrice">
                    <el-input v-model="allForm.cutPrice" placeholder="每吨优惠额(元/吨)"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" v-if="allFormType == 'add'" :loading="is_post" plain @click="addAllItem">保 存</el-button>
                    <el-button type="warning" v-else plain v-if="allFormType == 'edit'" :loading="is_post" @click="editAllItemSave">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--执行价格添加-->
        <el-dialog title="提交执行价" :visible.sync="add_price_dialog" width="30%">
            <el-form ref="priceForm" :model="priceForm" label-width="130px">
                <el-form-item label="执行价格(元/吨)" prop="price" :rules="[
                    {required:true,message:'请填写执行价格',trigger:'blur'},
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/ , message:'金额格式不正确,最多保留2位小数',trigger:'blur'}
                ]">
                    <el-input v-model="priceForm.price" type="number" placeholder="请填写执行价格(元/吨)"></el-input>
                </el-form-item>
                <el-form-item label="是否发送站内信">
                    <el-switch
                        v-model="priceForm.isSendMail"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否发送短信">
                    <el-switch
                        v-model="priceForm.isSendSms"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="savePrice" :loading="is_post">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/request'
import { deepClone } from '@/utils'
import {stringTrim} from '@/utils/elvalid'
import {mapGetters} from 'vuex'
import can from "@/directive/can/index.js"
import {formatDate} from "@/utils/index"
import checkPermission from '@/utils/permission' 

export default {
    name: 'goods_detail',
    props:["data","mode","companys"],
    directives:{can},
    computed: {
        ...mapGetters([
            'permissions',
        ])
    },
    data(){
        let validate_cut_price = (rule, value, callback) => {
            if (parseFloat(value) >= parseFloat(this.priceForm.realPrice)) {
                callback(new Error("优惠不能大于价格!"));
            } else {
                callback();
            }
            };
        return {
            active_index:"1",
            is_ok:false,
            selectInput:"",
            select_company_arr:[],
            form:{
                name:"",
                imgUrl:"",
                isMain:false,
                isShow:false
            },
            activeNames: 'first',
            id:0,
            is_upload:false,
            is_post:false,
            rules:{
                name:[
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ],
                imgUrl:[
                    { required: true, message: '请上传产品图片', trigger: 'blur' }
                ]
            },
            price_list:[],
            price_total:0,
            total:0,
            tableMaxHeight: 0,
            is_loading:false,
            selectVehicleForm:{
                pageNum:1,
                pageSize: 10,
                plateNumber: ""
            },
            vehicle_list:[],
            discountNum:0,
            selectForm:{
                goodsId:0,
                timeRange:[],
                pageNum:1,
                pageSize:5
            },
            priceForm:{
                price:"",
                isSendMail:false,
                isSendSms:false
            },
            add_prcie:false,
            addPerf:{
                beginDate:'',
                endDate:'',
                price:'',
                plateNumber:''
            },
            pref:{
                beginDate:[
                    {required: true, message: '请输入开始日期', trigger: 'blur'},
                ],
                endDate:[
                    {required: true, message: '请输入结束日期', trigger: 'blur'},
                ],
                price:[
                    {required: true, message: '请输入优惠价格', trigger: 'blur'},
                ],
                plateNumber:[
                    {required: true, message: '请输入主车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            discount_list:[],
            active_discount:"second",
            is_time_price: false,
            is_time_price_add:false,
            discount_list:[],
            goods_list: [],
            timePriceForm: {
                ids: [],
                realPrice: "",
                saleCutPrice: "",
                time: "",
                product: "",
                productId:"",
                
            },
            timePriceRules: {
                // product: [
                // { required: true, message: "请选择产品", trigger: "blur" }
                // ],
                realPrice: [
                { required: true, message: "请输入实际价格", trigger: "blur" },
                {
                    pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,
                    message: "请输入一个数字,最多保留2位小数",
                    trigger: "blur",
                },
                ],
                saleCutPrice: [
                { required: true, message: "请输入销售优惠", trigger: "blur" },
                {
                    pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,
                    message: "请输入一个数字,最多保留2位小数",
                    trigger: "blur",
                },
                { validator: validate_cut_price, trigger: "blur" },
                ],
                time: [
                { required: true, message: "请选择时间", trigger: "blur" }
                ],
            },
            //临时优惠设置
            temForm:{
                goodsId:0,
                temCutPrice:"",
                isTemCut:false
            },
            allowForm:{
                goodsId:0,
                allowQuota:""
            },
            add_dialog:false,
            add_discounts_dialog:false,
            allForm:{
                conditionNum:"",
                cutPrice:""
            },
            active_all:null,
            allFormType:"add",//add|edit,
            add_price_dialog:false,
            allFormRules:{
                conditionNum:[
                    { required: true, message: '请输入满足采购量', trigger: 'blur' },
                    { pattern:/^[1-9]\d*$/ ,message:"请输入一个正整数",trigger:"blur" }
                ],
                cutPrice:[
                    { required: true, message: '请输入要优惠的价格', trigger: 'blur' },
                    { pattern:/^[1-9]\d*$/ ,message:"请输入一个正整数",trigger:"blur" }
                ]
            },
            discount_circle_list:[],
            wordTime:'',
            isPriceChange:false,
            numRef:1,
            price_history_list:[],
        }
    },
    methods:{
        plateNumberInput(e){
            this.addPerf.plateNumber = e.toUpperCase();
        },
        checkPermission,
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        //选择图片
        choseImg(){
            this.$refs["upload_file"].click();
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        //上传图片
        file_change(e){
            let file = e.target.files[0];
            if(typeof file == "undefined"){
                return false;
            }
            this.is_upload = true;
            this.$store.dispatch("upload/uploadImg",{file:file,size:1024*512}).then(res=>{
                this.is_upload = false;
                this.form.imgUrl = res.url;
                this.$message.success("图片上传成功!");
            }).catch(err=>{
                if(err.type == "size"){
                    this.$message.warning("请上传不大于500kb的图片!");
                }else{
                    this.$message.warning(err.msg);
                }
                this.is_upload = false;
                console.log(err);
            });
        },
        price_page_change(page){
            this.selectForm.pageNum = page;
            this.getPriceList(false);
        },
        selectPrice(){
            this.getPriceList(false);
        },
                //定时调价
        timedPrice() {
        // this.is_time_price = true;
        //    this.getDataList();
        },
        timedPriceAdd() {
            this.is_time_price_add = true;
        },
        //定时调价列表
        getDataList(){
            request.get('order/time/get_price').then(res=>{
                if(res.code==200){
                    if(res.data!=null||res.data!=''){
                        this.discount_list=res.data
                        // var newArr=[];
                        // for(let i=0;i<this.discount_list.length;i++){
                        //     // debugger
                        //     if(this.discount_list[i].goodsName==this.timePriceForm.product){
                        //         newArr.push(this.discount_list[i]);
                        //     }
                        // }
                    }
                }
            })
        },
        //删除定时调价
        delAllItem(item,index){
            request.post('order/time/delete_price',{id:item.id}).then(res=>{
                if(res.code==200){
                    this.$message.success('删除成功');
                    // this.getDataList();
                }
            })
        },
          // 定时调价
    submitTimePriceChange() {
      this.$refs["timePriceForm"].validate((valid) => {
        if (!valid) return false;
        this.is_post = true;
        let comIds = []
        this.select_company_arr.forEach(item =>{
            comIds.push(item.id)
        })
        request
          .post("order/time/edit_price", {
            price: this.timePriceForm.realPrice,
            goodsId: this.timePriceForm.productId,
            exeTime:this.timePriceForm.time,
            comIds:comIds
          })
          .then((res) => {
            this.$message.success("定时调价操作成功!");
            this.is_post = false;
            this.is_time_price_add=false;
            this.select_company_arr = [];
            this.getPriceHistory();
            this.getCompany();
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    //保存价格函
    submitPriceChange(){
         this.isPriceChange=true;
        // if(this.timePriceForm.time!=''||this.timePriceForm.time!=''){
           
        // }else{
        //     this.$message.error('请输入信息');
        // }
        
        // if(this.timePriceForm.time!=''){
        //     console.log(this.timePriceForm.time.replace("\"", ""),'45');
        //     this.wordTime=formatDate(this.timePriceForm.time.replace("\"", ""));
        // }
    },
        // 转换时间戳
        formateTimeStamp(time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month =
                date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minute =
                date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            // var second =
            //     date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return (
                year +"年" +month +"月" +day +"日 " +'<span style="margin-right:5px;">' +hour +":" +minute +"</span>" 
            );
        },
         // 转换时间戳
        formateTimeStamp1(time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month =
                date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            return (
                year +"年" +month +"月" +day +"日" 
            );
        },
        //提交价格函
        savePrice(){
            this.$refs["priceForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                request.post("goods/modify_price",{id:this.data.id,newPrice:this.priceForm.price,isSendSms:this.priceForm.isSendSms,isSendMail:this.priceForm.isSendMail}).then(res=>{
                    this.$notify({
                        title: '您的价格申请已提交成功',
                        message: '该产品的执行价格已提交审核,审核通过后将立即生效!',
                        type:'success'
                    });
                    this.priceForm.isSendSms = false;
                    this.priceForm.isSendMail = false;
                    this.add_price_dialog = false;
                    this.$refs["priceForm"].resetFields();
                    this.priceForm.price = "";
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        handleClick(e){
            if(e.index==3){
                this.getData();
                this.getDiscountNum();
            }
        },
        addDiscountOption(){
            this.allForm = {
                conditionNum:"",
                cutPrice:""
            };
            this.allFormType = "add";
            this.add_dialog = true;
        },
        deleteSubmit(){
            request.get("goods/delete?id="+this.data.id).then(res=>{
                if(res.code==200){
                    this.$message.success("产品删除成功");
                    this.$router.go(0)
                }
                
                }).catch(err=>{
                    this.is_post = false;
                });
        },
        addSubmit(){
            this.$refs["form"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                request.post("goods/create",this.form).then(res=>{
                    this.$message.success("新增产品成功");
                    this.form = {
                        name:"",
                        imgUrl:"",
                        isMain:false,
                        isShow:false
                    };
                    this.$refs["form"].resetFields();
                    this.$emit('getAdd',res.data);
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editSubmit(){
            this.$refs["form"].validate(valid=>{
                if(!valid)return false;
                let data = deepClone(this.form);
                data.id = this.data.id;
                this.is_post = true;
                request.post("goods/edit",data).then(res=>{
                    if(this.data.isMain && !data.isMain){
                        this.$emit('setMain',data);
                    }else if(!this.data.isMain && data.isMain){
                        this.$emit('setMain',data);
                    }
                    this.$emit("setData",data);
                    this.$message.success("修改产品信息成功");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        addOnePrice(){
            this.add_price_dialog = true;
        },
        //保存临时优惠策略
        saveTemForm(){
            this.$refs["temForm"].validate(valid=>{
                if(!valid) return false;
                this.temForm.goodsId = this.data.id;
                this.is_post = true;
                request.post("goods/modify_tem_cut",this.temForm).then(res=>{
                    this.$message.success("长期优惠设置成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        //保存销售优惠额度
        saveAllowForm(){
            this.$refs["allowForm"].validate(valid=>{
                if(!valid)return false;
                this.allowForm.goodsId = this.data.id;
                this.is_post = true;
                request.post("goods/modify_allow_quota",this.allowForm).then(res=>{
                    this.$message.success("销售员优惠保存成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        //保存全局优惠策略
        saveAllForm(){
            if(this.discount_list.length == 0){
                this.$message.warning("请设置该产品的全局优惠策略");
                return false;
            }
            let data = JSON.stringify(this.discount_list);
            this.is_post = true;
            request.post("goods/modify_discount_option",{goodsId:this.data.id,content:data}).then(res=>{
                // this.$message.success("该产品的全局优惠已提交审核,审核通过后将生效!");
                this.$notify({
                    title: '您的全局优惠申请已提交成功',
                    message: '该产品的全局优惠已提交审核,审核通过后将生效!'
                });
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        //添加一条全局优惠策略
        addAllItem(){
            this.$refs["allForm"].validate(valid=>{
                if(!valid) return false;
                let data = deepClone(this.allForm);
                this.discount_list.push(data);
                this.$refs["allForm"].resetFields();
                this.allForm = {
                    conditionNum:"",
                    cutPrice:""
                };
                this.add_dialog = false;
            });
        },
        editAllItemSave(){
            this.$refs["allForm"].validate(valid=>{
                if(!valid) return false;
                let data = deepClone(this.allForm);
                this.active_all.cutPrice = data.cutPrice;
                this.active_all.conditionNum = data.conditionNum;
                this.$refs["allForm"].resetFields();
                this.allForm = {
                    conditionNum:"",
                    cutPrice:""
                };
                this.add_dialog = false;
            });
        },

        editAllItem(item,i){
            this.active_all = item;
            this.allForm.conditionNum = item.conditionNum;
            this.allForm.cutPrice = item.cutPrice;
            this.allFormType = "edit";
            this.add_dialog = true;
        },
        delAllItem(item,i){
            this.discount_list.splice(i,1);
        },
        getPriceList(is_init = false){
            if(!is_init){
                this.is_post = true;
            }
            request.post("goods/price_history",this.selectForm).then(res=>{
                this.price_list = res.data.list;
                this.price_total = res.data.total;
                if(!is_init){
                    this.is_post = false;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_post = false;
                }
            });
        },
        setMainFalse(v){
            this.form.isMain = false;
        },
        getPrice(){
            request.get("order/time/get_price/"+this.data.id).then(res=>{
                this.timePriceForm.realPrice =res.data.newPrice;
                this.timePriceForm.time =res.data.exeTime;
            }).catch(err=>{

            });
        },
        pageChange(page){
            this.selectVehicleForm.pageNum = page;
            this.getData();
        },
        getData(){
            request.post("/car/discount_list",this.selectVehicleForm).then(res=>{
                this.vehicle_list=res.data.list;
                this.total=res.data.total;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectVehicleForm.$el.offsetHeight-85;
            }).catch((err)=>{
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectVehicleForm.$el.offsetHeight-85;
            })
        },
        //查询
        selectSubmit(){
            this.getData();
        },
        //重置
        resetSelect(){
            this.selectVehicleForm={
                pageNum:1,
                pageSize: 10,
                plateNumber:''
            }
            this.getData();
        },
        //新建
        goToAdd(){
            this.addPerf={
                plateNumber:'',
                price:'',
                beginDate:'',
                endDate:'',
            },
            this.add_prcie=true;
            this.add_discounts_dialog=true;
        },
        //关闭
        closeing(){
            this.add_prcie=false;
        },
        //编辑
        handleEdit(i,r){
            this.add_prcie=false;
            this.add_discounts_dialog=true;
            this.addPerf.id=r.id;
            this.addPerf.plateNumber=r.plateNumber;
            this.addPerf.price=r.price;
            this.addPerf.beginDate=r.beginDate;
            this.addPerf.endDate=r.endDate;
        },
        //删除
        handleDel(i,r){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let id=r.id
                request.post('/car/del_discount',{id:id}).then(res=>{
                    if(res.code==200){
                        this.$message.success('车辆优惠删除成功！')
                        this.getData();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            })
        },
        //车辆优惠确认
        addPrefSubmit(){
            this.$refs["addPerf"].validate(valid=>{
                if(!valid) return false;
                request.post('/car/add_discount',this.addPerf).then(res=>{
                    if(res.code==200){
                        this.$message.success('添加车辆优惠成功！')
                        this.add_discounts_dialog=false;
                        this.add_prcie=true;
                        this.addPerf.plateNumber='';
                        this.addPerf.beginDate='';
                        this.addPerf.endDate='';
                        this.addPerf.price='';
                        this.getData();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
                })
        },
        editPrefSubmit(){
            this.$refs["addPerf"].validate(valid=>{
                if(!valid) return false;
                request.post('/car/edit_discount',this.addPerf).then(res=>{
                    if(res.code==200){
                        this.$message.success('修改车辆优惠成功！')
                        this.add_discounts_dialog=false
                        this.add_prcie=true
                        this.getData();
                        
                    }else{
                        this.$message.error(res.msg)
                    }
                })
                })
        },
         getDiscountNum(){
            request.post("car/discount_num").then(res=>{
                this.discountNum =res.data;
            }).catch(err=>{

            });
        },
        selectCompany(e){
            console.log(e)
            this.selectInput = "";
            let num = this.companys.indexOf(e);
            if(num>-1){
                this.companys.splice(num,1);
                this.select_company_arr.push(e);
            }
        },
        deleteCompany(e){
            let num = this.select_company_arr.indexOf(e);
            if(num>-1){
                this.select_company_arr.splice(num,1);
                this.companys.push(e);
            }
        },
        getPriceHistory(){
            request.get("order/priceHistory/"+this.data.id).then(res=>{
               this.price_history_list = res.data
            }).catch(err=>{

            });
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.companys = res.data;
            }).catch(err=>{
            });
        },
    },

    created(){
        if(this.mode == 'add'){
            this.active_index = "1";
        }else{
            this.form.name = this.data.name;
            this.timePriceForm.product = this.data.name;
            this.form.imgUrl = this.data.imgUrl;
            this.form.isMain = this.data.isMain;
            this.form.isShow = this.data.isShow;
            this.allowForm.allowQuota = this.data.allowQuota;
            this.temForm.temCutPrice = this.data.temCutPrice;
            this.temForm.isTemCut = this.data.isTemCut?true:false;
            if(typeof this.data.discountContent == "string"){
                this.discount_list = JSON.parse(this.data.discountContent);
            }
            this.selectForm.goodsId = this.data.id;
            this.timePriceForm.productId = this.data.id;
            if( this.numRef==1){
                request.get("order/time/get_price/"+this.data.id).then(res=>{
                    this.timePriceForm.realPrice =res.data.newPrice;
                    this.timePriceForm.time =res.data.exeTime;
                }).catch(err=>{

                });
                this.getPriceHistory();
               
            }
            this.numRef++;
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
    .textIndent{
        text-indent:2em;
    }
    .priceMargin{
        margin-bottom: 15px;
    }
    .priceHeight{
        line-height: 30px;
    }
    .boxFlexCenter{
        display: flex;
        justify-content: center;
    }
    .boxFlexEnd{
        display: flex;
        justify-content:flex-end;
    }
    .boxFlexBetween{
        display: flex;
        justify-content: space-between;
    }
    .boxTitle{
        font-size: 28px;
        font-weight: bold;
        margin: 25px 0 3px 0;
    }
    .boxTitleS{
        font-size: 24px;
        font-weight: bold;
        margin: 15px 0 20px 0;
    }
    .boxBold{
        font-weight: bold;
    }
    .fontColor{
        color: red;
    }
    .boxLine{
        background: #383737;
        height: 2px;
        width: 100%;
    }
    .box-img{
        width: 140px;
        margin-right: 7%;
    }
    .boxPlace{
        width: 40%;
        display: flex;
        align-items: center;
    }
    .demo-form-inline{
        margin: 5px 2%;
    }
    .search-box{
        display: flex;
        justify-content: space-between;
        align-content: center;
    }
    .btn-save{
        display: flex;
        justify-content: center;
        margin-right: 100px;
    }
    .font-style{
        font-size: 14px;
        color: #606266;
        margin-right: 10px;
    }

    .select-company{
		margin: 8px 0 14px 30px;
		display: flex;
		align-items: center;
        border-radius: 4px;
		justify-content: space-between;
		background-color: rgba(80, 151, 230, 0.16);
	}
	
	.select-company-title{
		margin-left: 8px;
		font-size: 14px;
		padding: 10px;
		color: #007aff;
        width:90%
	}
</style>
